import React from 'react'
import { useTranslation } from 'react-i18next'
import { WidgetGuard } from 'features/types'
import { useDashboardWidgetData } from 'hooks/useWidgetState'
import { AnnotatedMetricResult } from 'schemas/AnnotatedMetricResultSchema'
import ErrorMessage from 'components/share/ErrorMessage'
import MetricSeries from 'enums/MetricSeries'
import { retrieveDataset } from '../utils'

const SummaryMetricsCompactNoDataGuard: WidgetGuard = ({ widgetId, children }) => {
  const widgetData = useDashboardWidgetData<AnnotatedMetricResult>(widgetId)
  const { t } = useTranslation()

  const mentionsDataset = widgetData.data
    .map((data) =>
      retrieveDataset(data).filter((dataset) => dataset.seriesName === MetricSeries.TOTAL_BUZZ)
    )
    .flat()

  const isEveryMentionZero = mentionsDataset.every((dataset) => dataset?.set?.[0] === 0)

  if (isEveryMentionZero) {
    return <ErrorMessage>{t('noDataFoundInWidget')}</ErrorMessage>
  }
  return children
}

export default SummaryMetricsCompactNoDataGuard
